export default async function init() {
  const elements = document.querySelectorAll('.navigation');

  const { default: Navigation } = await import(/* webpackChunkName: "navigation" */ './navigation');

  elements.forEach((element) => new Navigation(element));
}
